import {Button, Grid, Surface, Tab, Text, useTheme} from "tmwx-design-web/src";
import {useEffect, useMemo, useState} from "react";
import {isEmpty} from "gui-common/appHelper";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {usePermissions} from "tmwx-design-common";
import {ColumnDef} from "@tanstack/react-table";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import constants from "gui-common/constants.json";
import {Register, Template} from "gui-common/redux/data/register";
import {getRegisterList} from "gui-common/redux/action/efe/registerActions";
import {registerActions} from "gui-common/redux/slice/efe/registerSlice";
import TemplateSearchModal from "../../components/efe/TemplateSearchModal";
import RegisterTestTable from "../../components/efe/RegisterTestTable";

const TestRegisterTable = () => {
    const {t} = useTranslation()
    const {padding, roundness} = useTheme()
    const dispatch: any = useDispatch()
    const {hasRights} = usePermissions()
    const [label, setLabel] = useState<string>('');
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedTemplate = useSelector<RootState, Template>(state => state.register.selectedTemplate)
    const registerList = useSelector<RootState, Register[]>(state => state.register.registerList);
    const loading = useSelector<RootState, boolean>(state => state.register.loading);

    useEffect(() => {
        if (!isEmpty(selectedTemplate.dteTemplateTag) && !isEmpty(selectedTemplate.dteTemplateName) && !isEmpty(selectedTemplate.dteDeviceTypeTag)) {
            setLabel(selectedTemplate.dteTemplateName + ' - ' + selectedTemplate.dteTemplateTag + ' (' + selectedTemplate.dteDeviceTypeTag + ')')
            const podTag = selectedTemplate.dteTemplateTag
            const templateName = selectedTemplate.dteTemplateName
            const deviceType = selectedTemplate.dteDeviceTypeTag
            setSearchParams({ podTag, templateName, deviceType });

            if (hasRights(["efe_registers_view"])) {
                dispatch(getRegisterList(selectedTemplate.dteTemplateTag))
            }
        }
    }, [selectedTemplate])

    useEffect(() => {
        const podTag = localStorage.getItem(constants.POD_TAG);
        const templateName = localStorage.getItem(constants.TEMPLATE_NAME);
        const deviceType = localStorage.getItem(constants.DEVICE_TYPE);

        if (podTag != null  && templateName != null && deviceType != null)  {
            dispatch(registerActions.setSelectedTemplate({
                dteTemplateTag: podTag,
                dteTemplateName: templateName,
                dteDeviceTypeTag: deviceType
            }))
        }
    }, [dispatch])

    useEffect(() => {
        const searchPodTag = searchParams.get("podTag") as string;
        const searchTemplateName = searchParams.get("templateName") as string;
        const searchDeviceType = searchParams.get("deviceType") as string;

        if (searchPodTag != null && searchTemplateName != null && searchDeviceType != null)  {
            localStorage.setItem(constants.POD_TAG, searchPodTag);
            localStorage.setItem(constants.TEMPLATE_NAME, searchTemplateName);
            localStorage.setItem(constants.DEVICE_TYPE, searchDeviceType);

            dispatch(registerActions.setSelectedTemplate({
                dteTemplateTag: searchPodTag,
                dteTemplateName: searchTemplateName,
                dteDeviceTypeTag: searchDeviceType
            }))
        }
    }, [searchParams])

    return (
        <Surface style={{height: '100vh', paddingTop: 8, paddingBottom: 8}}>
            <Grid.Container style={{borderRadius: roundness}} maxWidth='xl' elevation={0} centered>
                <Grid.Col m={6} lg={6} xl={6}>
                    <TemplateSearchModal label={label}/>
                </Grid.Col>

                <Grid.Col>
                    {!isEmpty(selectedTemplate) &&
                        <Tab
                            elevation={0}
                            contentMode='keep'
                            menuItems={[
                                {
                                    title: t('efe.registers'),
                                    icon: 'info_outlined',
                                    component: (
                                        <RegisterTestTable podTag={selectedTemplate.dteTemplateTag} deviceType={selectedTemplate.dteDeviceTypeTag}/>
                                    )
                                }
                            ]}
                        />
                    }
                </Grid.Col>
            </Grid.Container>
        </Surface>
    )
}

export default TestRegisterTable;